module.exports = __webpack_public_path__ + "static/media/history-icon.4d6076f2.png";